"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementsToJSON = exports.AgreementsFromJSONTyped = exports.AgreementsFromJSON = void 0;
const runtime_1 = require("../runtime");
function AgreementsFromJSON(json) {
    return AgreementsFromJSONTyped(json, false);
}
exports.AgreementsFromJSON = AgreementsFromJSON;
function AgreementsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'termsAndConditions': json['termsAndConditions'],
        'certifyAccurateData': json['certifyAccurateData'],
        'promotionalMarketing': json['promotionalMarketing'],
        'guardianAuthorization': json['guardianAuthorization'],
        'bipa': !runtime_1.exists(json, 'bipa') ? undefined : json['bipa'],
    };
}
exports.AgreementsFromJSONTyped = AgreementsFromJSONTyped;
function AgreementsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'termsAndConditions': value.termsAndConditions,
        'certifyAccurateData': value.certifyAccurateData,
        'promotionalMarketing': value.promotionalMarketing,
        'guardianAuthorization': value.guardianAuthorization,
        'bipa': value.bipa,
    };
}
exports.AgreementsToJSON = AgreementsToJSON;
//# sourceMappingURL=Agreements.js.map